<template>
  <div v-if="Urun_id">
    <el-row :gutter="24">
      <el-col :span="18">
        <el-table
          :data="Liste"
          class="golgetable"
          height="94vh"
          @current-change="TableSecim">
          <el-table-column
            label="Hareket Tarihi"
            prop="tarih"
            width="150">
          </el-table-column>
          <el-table-column
            label="Açıklama"
            prop="Aciklama">
          </el-table-column>
          <el-table-column
            label="Kullanıcı"
            prop="Ekleyen"
            width="150">
          </el-table-column>
          <el-table-column
            label="Giriş"
            prop="Giris"
            align="right"
            width="70">
          </el-table-column>
          <el-table-column
            label="Çıkış"
            prop="Cikis"
            align="right"
            width="70">
          </el-table-column>
          <el-table-column
            label="Bakiye"
            prop="Bakiye"
            align="right"
            width="70">
          </el-table-column>
        </el-table>
        <el-dialog
          append-to-body
          title="Hareket Detay"
          :visible.sync="HareketDetayModal"
          width="50%">
          <a @click="HareketDetayModal=false" class="ModalKapat"><i class="el-icon-close"></i></a>
          <el-row :gutter="24" v-if="HareketSecim">
            <el-col :span="6">
              <table class="table table-xs table-bordered">
                <thead>
                <tr>
                  <th colspan="4">Hareket Bilgi</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <small class="d-block">Hareket Tarihi</small>
                    {{ HareketSecim.tarih }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <small class="d-block">Hareket Açıklama</small>
                    {{ HareketSecim.Aciklama }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <small class="d-block">Hareket Kullanıcı</small>
                    {{ HareketSecim.Ekleyen }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <small class="d-block">Hareket Tür</small>
                    {{ HareketSecim.Tur }}
                  </td>
                </tr>
                </tbody>
              </table>
            </el-col>
            <el-col :span="18">
              <table class="table table-bordered table-xs">
                <thead>
                <tr>
                  <th :colspan="HareketSecim.Tur=='Giriş'?2:3">Stok Hareket</th>
                </tr>
                <tr>
                  <th>Giriş Tarihi</th>
                  <th v-if="HareketSecim.Tur=='Çıkış'">Çıkış Tarihi</th>
                  <th>Seri No</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="d in HareketDetay">
                  <td>{{ HareketSecim.Tur == 'Çıkış' ? d.Giris : d.tarih }}</td>
                  <td v-if="HareketSecim.Tur=='Çıkış'">{{ d.tarih }}</td>
                  <td>{{ d.Seri }}</td>
                </tr>
                </tbody>
              </table>
            </el-col>
          </el-row>
        </el-dialog>
      </el-col>
      <el-col :span="6">
        <Hareket @SayfaYenile="SayfaYukle()" :Urun_id="Urun_id"></Hareket>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Hareket from "./Comp/Hareket";

export default {
  components: {Hareket},
  props: ['Urun_id'],
  data() {
    return {
      Liste: null,
      YeniUrunModal: false,
      HareketDetayModal: false,
      HareketDetay: null,
      HareketSecim: null,
      HareketListe: null,
    }
  },
  methods: {
    SayfaYukle() {
      this.$store.dispatch("Get", {
        path: '_enerji/stok/detay/' + this.Urun_id
      })
        .then(response => {
          this.Liste = response.Liste
        })
    },
    TableSecim(val) {
      this.HareketSecim = val
      this.HareketDetayModal = true
      this.$store.dispatch("Get", {
        path: '_enerji/stok/detay/' + this.Urun_id + '/' + val.Grup
      })
        .then(response => {
          this.HareketDetay = response.Detay
        })
    }
  },
  created() {
    this.SayfaYukle();
  },
  computed: {
    SayfaYenile() {
      return this.Urun_id
    },
  },
  watch: {
    SayfaYenile() {
      this.SayfaYukle();
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Stok/Detay.vue